import React from 'react';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import ModalOuterContainer from '../containers/ModalOuterContainer';
import ButtonContainer from 'components/shared/generic/buttonContainer/presentational/ButtonContainer';
import Button from 'components/shared/generic/button/presentational/Button';

interface SuccessModalProps {
    title?: string;
    message?: string;
    hideModal: () => void;
}

const SuccessModal = ({
    title = 'Success',
    message = 'Task completed',
    hideModal,
}: SuccessModalProps) => (
    <ModalOuterContainer customButtons className="status-modal">
        <div className="description">
            <Typography tag="h1">{title}</Typography>
            <div className="modal-icon">
                <i className="fa fa-check-circle" />
            </div>
            <Typography className="generic-text intro-text">
                {message}
            </Typography>
        </div>
        <ButtonContainer className="center">
            <Button onClick={hideModal}>Close</Button>
        </ButtonContainer>
    </ModalOuterContainer>
);

export default SuccessModal;
